import { render } from "./EvalvationQuestionnaireTables.vue?vue&type=template&id=767442a0"
import script from "./EvalvationQuestionnaireTables.vue?vue&type=script&lang=js"
export * from "./EvalvationQuestionnaireTables.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__